import classNames from 'classnames';
import AnimateHeight from 'react-animate-height';
import styles from './podcast-links.module.css';

import { PodcastLinksInterface } from './podcast-links.interface';
import {
  Apple,
  Mave,
  Google,
  Yandex,
  Addict,
  Castbox,
  Pocket,
  Overcast,
  Deezer,
  Spotify,
} from './icons';

const PodcastLink: React.FunctionComponent<{
  href?: string;
}> = ({ children, href }) => {
  return (
    <a
      className={styles.podcastLink}
      href={href}
      target="_blank"
      rel="noreferrer"
    >
      {children}
    </a>
  );
};

const PodcastLinks: React.FunctionComponent<PodcastLinksInterface> = ({
  id,
  className,
  isOpened = true,
  links,
}) => {
  return (
    <article
      id={id}
      className={classNames(
        styles.component,
        className,
        {
          [styles.isOpened]: isOpened,
        },
      )}
    >
      <AnimateHeight
        duration={500}
        height={isOpened ? 'auto' : 0}
      >
        <div className={classNames(styles.links)}>
          <PodcastLink href={links.apple}>
            <Apple.LogoIcon />
            <Apple.TitleIcon />
          </PodcastLink>

          <PodcastLink href={links.google}>
            <Google.LogoIcon />
            <Google.TitleIcon />
          </PodcastLink>

          <PodcastLink href={links.yandex}>
            <Yandex.LogoIcon />
            <Yandex.TitleIcon />
          </PodcastLink>

          <PodcastLink href={links.spotify}>
            <Spotify.LogoIcon />
            <Spotify.TitleIcon />
          </PodcastLink>

          <PodcastLink href={links.mave}>
            <Mave.LogoIcon />
            <Mave.TitleIcon />
          </PodcastLink>

          <PodcastLink href={links.deezer}>
            <Deezer.LogoIcon />
            <Deezer.TitleIcon />
          </PodcastLink>

          <PodcastLink href={links.overcast}>
            <Overcast.LogoIcon />
            <Overcast.TitleIcon />
          </PodcastLink>

          <PodcastLink href={links.addict}>
            <Addict.LogoIcon />
            <Addict.TitleIcon />
          </PodcastLink>

          <PodcastLink href={links.castbox}>
            <Castbox.LogoIcon />
            <Castbox.TitleIcon />
          </PodcastLink>

          <PodcastLink href={links.pocket}>
            <Pocket.LogoIcon />
            <Pocket.TitleIcon />
          </PodcastLink>
        </div>
      </AnimateHeight>
    </article>
  );
};

export default PodcastLinks;
